var _style, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFD546;}\r\n\t.st2{fill:none;stroke:#333333;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#333333;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8968,
    y1: 56.3948,
    x2: 31.7623,
    y2: 16.7906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2DEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2478,
    style: {
      stopColor: "#FFD546",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,14.1c-11.1,0-20.2,9-20.2,20.2c0,4.5,1.5,8.7,4.1,12.1l-1.7,6.4c-0.2,0.6,0.4,1.1,1,1l6.9-1.8 c0,0,0.1,0,0.1,0c2.9,1.7,6.3,2.6,9.9,2.6c11.1,0,20.2-9,20.2-20.2S32.8,14.1,21.7,14.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,0C50,0,56,6,56,13.3c0,3-1,5.7-2.7,8l1.1,4.2c0.1,0.4-0.2,0.7-0.6,0.6l-4.5-1.2c0,0,0,0-0.1,0 c-1.9,1.1-4.2,1.7-6.5,1.7c-7.3,0-13.3-6-13.3-13.3S35.3,0,42.7,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,24.9l3,4.8l5.5,1.4c0.7,0.2,1.1,0.8,0.9,1.5c0,0.2-0.1,0.4-0.3,0.5l-3.6,4.3l0.4,5.6 c0,0.7-0.5,1.3-1.2,1.3c-0.2,0-0.4,0-0.5-0.1l-5.3-2.1l-5.3,2.1c-0.6,0.3-1.3-0.1-1.6-0.7c-0.1-0.2-0.1-0.4-0.1-0.5l0.4-5.6 L11.5,33c-0.4-0.5-0.4-1.3,0.1-1.7c0.1-0.1,0.3-0.2,0.5-0.3l5.5-1.4l3-4.8c0.4-0.6,1.1-0.7,1.7-0.4C22.5,24.6,22.6,24.7,22.7,24.9z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.7,14.1c-11.1,0-20.2,9-20.2,20.2c0,4.5,1.5,8.7,4.1,12.1l-1.7,6.4c-0.2,0.6,0.4,1.1,1,1l6.9-1.8 c0,0,0.1,0,0.1,0c2.9,1.7,6.3,2.6,9.9,2.6c11.1,0,20.2-9,20.2-20.2S32.8,14.1,21.7,14.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.2,13.3c0,0.6-0.4,1.1-1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.4-1,1-1.1l0,0c0.6,0,1,0.4,1.1,0.9 c0,0,0,0,0,0L38.2,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,12.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1 C41.6,12.7,42.1,12.2,42.7,12.2C42.7,12.2,42.7,12.2,42.7,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.3,12.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1 C47.2,12.7,47.7,12.2,48.3,12.2C48.3,12.2,48.3,12.2,48.3,12.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.3eb222c79987f001b7be144bb7ba4792.svg";
export { ForwardRef as ReactComponent };